import React from 'react'
import Link from '../../Link'
import { FormattedMessage } from 'react-intl'


//компонент меню для роли пользователя (включая неавторизованного), содержащий ссылки с левой стороны
const HeaderMenuUser = ({data}) => {
    return ( 
        <div className='Header__menu'>
            <Link to='/lots' className='Header__menu-link'>
                <FormattedMessage id='header.auctions' />
            </Link>
            {!data.hideArt
            ?
            <Link to='/arts' className='Header__menu-link Persons__Link_active'>
                <FormattedMessage id='header.arts' />
            </Link>
            : null}
            <Link to='/fixedpricelots' className='Header__menu-link'>
                <FormattedMessage id='header.fixedprices' />
            </Link>
            <Link to='/funds' className='Header__menu-link'>
                <FormattedMessage id='header.foundations' />
            </Link>
            <Link to='/members' className='Header__menu-link'>
                <FormattedMessage id='header.participants' />
            </Link>
            { <Link to='/aboutus' className='Header__menu-link'>
                <FormattedMessage id='header.aboutus' />
            </Link> }
        </div>
    )
}

export default HeaderMenuUser;


// WEBPACK FOOTER //
// ./src/components/MenuComponents/menu/HeaderMenuUser.jsx